<template>
    <v-container>
      <v-row>
        <v-dialog v-model="clearRouteDialog" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">Clear this route?</v-card-title>
            <v-card-text>
              Are you sure you want to remove your drawn route? You will need to draw the route again to answer
              this
              question.
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" outlined flat @click.native="clearRouteDialog = false">Cancel</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="error" depressed @click.native="confirmClear">I am sure</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--  :class="!stateInfo.startDraw ? 'isDrawing' : ''"  -->
        <map-component assess
                       :class="!stateInfo.startDraw ? 'isDrawing' : ''"
                       :states.sync="stateInfo"
                       @map-toolbar-clear="handleClear"
                       @map-click="handleMapClick"
                       @go-home="handleGoHome"
                       @map-toolbar-undo="handleUndo"
                       @assess-start-draw="handleStartDrawing"
                       @assess-stop-draw="handleStopDrawing"
                       @map-created="handleMapCreated"></map-component>
      </v-row>
    </v-container>
</template>

<script>
  import MapComponent from './MainContent/Map'
  import 'gox'
  import GeoJSON from 'ol/format/GeoJSON.js'
  let cursorImage = require('../assets/cursors/crosshair_32.png');

  import {mapActions, mapGetters} from 'vuex'

  export default {
    name: 'AssessNew',

    mounted() {
      document.addEventListener('contextmenu', event => event.preventDefault());

      window.addEventListener("resize", () => {
        if (this.map) {
          this.handleGoHome();
        }
      });
    },

    components: {
      MapComponent
    },

    computed: {
      ...mapGetters(['ASSESS_GET_QUESTION', 'getIcons']),
    },

    data() {
      return {
        clearRouteDialog: false,
        drawLayer: null,
        lastDrawView: null,
        map: null,
        pointsLayer: null,
        drawStyle: () => {
          let style = new GOX.Style();
          let outline = style.JSONtoStyle({
            stroke: {
              width: 6,
              color: 'white'
            }
          });
          let inner = style.JSONtoStyle({
            stroke: {
              width: 3,
              color: 'green'
            }
          });

          return [outline, inner]
        },
        startPointStyle: () => {
          let style = new GOX.Style();
          let JSONStyle = style.JSONtoStyle({
            image: {
              src: require('../assets/icons/' + this.getIcons.start),
              anchor: [0.5, 48],
              anchorXUnits: 'fraction',
              anchorYUnits: 'pixels'
            }
          });

          return JSONStyle
        },
        endPointStyle: () => {
          let style = new GOX.Style();
          let JSONStyle = style.JSONtoStyle({
            image: {
              src: require('../assets/icons/' + this.getIcons.end),
              anchor: [0.5, 48],
              anchorXUnits: 'fraction',
              anchorYUnits: 'pixels'
            }
          });

          return JSONStyle
        },
        firstDrawnPointStyle: () => {
          let style = new GOX.Style();
          let jsonStyle = style.JSONtoStyle({
            image: {
              src: require('../assets/icons/' + this.getIcons.candidateStart),
              anchor: [12, 12],
              anchorXUnits: 'pixels',
              anchorYUnits: 'pixels'
            }
          });

          return jsonStyle
        },
        stateInfo: {
          undo: false,
          startDraw: true,
          stopDraw: false
        }
      }
    },

    methods: {
      addPointToLine(e) {
        let features = this.drawLayer.getSource().getFeatures();

        console.log("FEATURES", features)

        //if there are no features well need to manually create the geom/feature and add it.
        if (!features.length) {
          console.log("ADD FIRST POINT")
          //add the first point:
          let pointFeature = new GOX.Feature.Point();
          console.log("POINT FEATURE", pointFeature);
          pointFeature.getGeometry().setCoordinates([e.coordinate[0], e.coordinate[1]]);
          pointFeature.setStyle(this.firstDrawnPointStyle);
          pointFeature.isFirstDrawnPoint = true;
          this.pointsLayer.getSource().addFeature(pointFeature)

          let theFeature = new GOX.Feature.Line();
          //create the geom
          let geomToAdd = theFeature.getGeometry();
          console.log("LINE STRING", geomToAdd)

          //tricking OL into thinking we've added two coords here, otherwise it wont respond to the first map click
          geomToAdd.setCoordinates([[e.coordinate[0], e.coordinate[1]], [e.coordinate[0], e.coordinate[1]]]);

          //create feature


          //add the geometry
          theFeature.setGeometry(geomToAdd);

          //now add it to the layer
          this.drawLayer.getSource().addFeature(theFeature);
        } else {
          console.log("A FEATURE EXISTS")
          //if there were features, we can just carry on
          let theGeom = features[0].getGeometry();
          let coordinates = theGeom.getCoordinates();
          console.log(coordinates);

          coordinates.push(e.coordinate);
          theGeom.setCoordinates(coordinates);
          features[0].set('stylegeom', undefined);
        }

        this.stateInfo.undo = true;
        this.emitRouteGeoJSON();

      },
      confirmClear() {
        //Set the toolbar states
        this.stateInfo.startDraw = true;
        this.stateInfo.stopDraw = false;
        this.stateInfo.undo = false;

        //clear the layer
        this.clearLayer();
        //close dialog
        this.clearRouteDialog = false;
        //emit the message to QuestionMark
        window.parent.postMessage({
          messageSource: "geoxphere",
          event: "draw-clear"
        }, "*");
      },
      createLayer() {
        console.log("Assess -- createLayer: ");
        this.pointsLayer = new GOX.Layer.Vector({
          id: 'points',
          geometry: 'Point'
        });
        this.map.addLayer(this.pointsLayer);
        this.pointsLayer.setZIndex(999)

        this.fetchPoints();
        console.log("POINTS FETCHED")

        let style = new GOX.Style();
        let outline = style.JSONtoStyle({
          stroke: {
            width: 6,
            color: [255, 255, 255, 1]
          }
        });
        let inner = style.JSONtoStyle({
          stroke: {
            width: 4,
            color: [0, 153, 255, 1]
          }
        });

        this.drawLayer = new GOX.Layer.Vector({
          id: 'assessment',
          geometry: 'LineString',
          style: [outline, inner],
          //restrictEditLevels: [11, 14]
        });

        this.drawLayer.setZIndex(99999)
        this.map.addLayer(this.drawLayer);

      },
      fetchPoints() {
        let startPoint = this.ASSESS_GET_QUESTION.startpoint.split(',');
        let endPoint = this.ASSESS_GET_QUESTION.endpoint.split(',');
        console.log("startPoint: " + startPoint);
        console.dir(this.ASSESS_GET_QUESTION);

        /*        var sgeom = new GOX.Geom.Point();
                sgeom.setCoordinates(startPoint);*/
        var feature = new GOX.Feature.Point();
        feature.getGeometry().setCoordinates(startPoint);
        feature.setStyle(this.startPointStyle);
        this.pointsLayer.getSource().addFeature(feature);

        /*   var egeom = new GOX.Geom.Point();
           egeom.setCoordinates(endPoint);*/
        var feature = new GOX.Feature.Point();
        feature.getGeometry().setCoordinates(endPoint);
        feature.setStyle(this.endPointStyle);
        this.pointsLayer.getSource().addFeature(feature);

        this.map.updateSize();

        let extent = this.pointsLayer.getFeaturesExtent();
        this.map.setExtent(extent);
      },
      handleClear() {
        this.clearRouteDialog = true;
      },
      handleGoHome() {
        //stop drawing when user clicks home - send a flag to disable emit of coords.
        this.handleStopDrawing(true);

        var src = this.pointsLayer.getSource();
        if (src.getFeatures().length > 1) {
          this.map.setExtent(this.pointsLayer.getSource().getExtent());
          this.map.getView().setZoom(this.map.getView().getZoom() - 1)
        } else {
          this.map.setExtent(this.pointsLayer.getSource().getExtent(), 15);
        }
      },
      handleMapCreated(map) {
        console.log("AssessNew -- handleMapCreated: ");
        this.map = map;
        this.createLayer();
        this.handleGoHome();
      },
      handleStartDrawing() {

        //document.body.style = "cursor: crosshair";

        let style = new GOX.Style();
        let outline = style.JSONtoStyle({
          stroke: {
            width: 6,
            color: [255, 255, 255, 1]
          }
        });
        let inner = style.JSONtoStyle({
          stroke: {
            width: 4,
            color: [0, 153, 255, 1]
          }
        });
        let vertices = style.JSONtoStyle({
          //showVertex: true,
          fill: {
            color: 'blue'
          },
          symbol: {
            size: 6,
            fill: {
              color: 'blue'
            }
          },
        });

        this.drawLayer.setStyle([outline, inner, vertices]);

        //check the last draw view and go back to it if possible
        /*        if (this.lastDrawView) {
         this.map.getView().setCenter(this.lastDrawView.center)
         this.map.getView().setZoom(this.lastDrawView.zoom)
         }*/

        //Hide the start drawing button
        this.stateInfo.startDraw = false;

        //Show the stop drawing button
        this.stateInfo.stopDraw = true;
      },
      handleStopDrawing(noemit) {
        console.log("AssessNew -- handlestopDrawing: ");
        //document.body.style = "cursor: auto";
        //Hide the start drawing button
        this.stateInfo.startDraw = true;

        //Show the stop drawing button
        this.stateInfo.stopDraw = false;

        let style = new GOX.Style();

        let newStyle = style.JSONtoStyle({
          stroke: {
            width: 5,
            color: 'purple'
          }
        });

        this.drawLayer.setStyle(newStyle)

        if (!noemit) {
          this.emitRouteGeoJSON();
        }

      },
      emitRouteGeoJSON() {
        //get the features
        let features = this.drawLayer.getSource().getFeatures();

        //write them as geoJSON

        let geoJSON = new GeoJSON({
          dataProjection: 'EPSG:27700'
        }).writeFeatures(features);

        //emit them to QM
        window.parent.postMessage({
          messageSource: "geoxphere",
          event: "draw-end",
          data: geoJSON
        }, "*");

        console.dir(geoJSON)
      },
      handleMapClick(e) {
        if (this.stateInfo.stopDraw) {
          this.addPointToLine(e);
        }
      },
      clearLayer() {
        this.removeFirstDrawnPointMarker();
        this.lastDrawView = null;
        this.drawLayer.getSource().clear(); //remove the line
        this.stateInfo.undo = false;
      },
      removeFirstDrawnPointMarker() {
        this.pointsLayer.getSource().getFeatures().forEach(feature => {
          if (feature.isFirstDrawnPoint) {
            this.pointsLayer.getSource().removeFeature(feature)
          }
        })
      },
      handleUndo() {
        let features = this.drawLayer.getSource().getFeatures();

        if (features.length) {
          let theGeom = features[0].getGeometry();
          let currentCoords = theGeom.getCoordinates();
          currentCoords.pop();

          //Disable undo if there's nothing left to remove.
          if (currentCoords.length === 1) {
            this.clearLayer();
          }

          theGeom.setCoordinates(currentCoords);
          //emit everything back
          this.emitRouteGeoJSON();
        }
      }
    }
  }
</script>


<style>
    html {
        overflow-y: hidden !important;
    }

    .isDrawing {
        cursor: url('../assets/cursors/cursor_blue_24.png') 12 12, crosshair;
    }
</style>
